import { useEffect } from 'react';
import { registerSW } from 'virtual:pwa-register';

/**
 * Registers the service worker for PWA "Add to Home Screen" functionality.
 * 
 * Note: We don't cache assets - the app requires online access for ship data.
 * The SW exists only to enable PWA install on mobile devices.
 */
export function useServiceWorker() {
  useEffect(() => {
    registerSW({
      immediate: true,
    });
  }, []);
}
